export default "__VITE_ASSET__oFOSNixb__"